import gql from "../gql";
const Job = gql `
  fragment Job on JobDetail {
    __typename
    id
    title
    url
    company
    summary
    location
    minSalary
    maxSalary
    postedDate
  }
`;
export default gql `
  fragment Jobs on JobDetailConnection {
    __typename
    edges {
      __typename
      node {
        ...Job
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ${Job}
`;
